import { CARE_CANVAS_TEMPLATE_BY_ID } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Response {
    success: boolean;
    error?: string;
}

export default (id: string): Promise<Response> => {
    return fetchWithRefresh(CARE_CANVAS_TEMPLATE_BY_ID(id), { method: 'DELETE' }).then((res) =>
        res.json(),
    );
};
